/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { authMethodSchema } from './authMethodSchema';

export const authDescriptorSchema = z.object({
  get defaultMethod() {
    return authMethodSchema;
  },
  get supportedMethods() {
    return z.array(authMethodSchema);
  },
});
